'use client';
import { useRouter } from '@bprogress/next/app';
import { useState } from 'react';

import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import { UiKitCheckboxTag } from '@/fo/ui/kit/checkbox/tag';

import { SelectedFilters, TopCategories } from '../../types';

import { styles } from './CategoriesTagsList.styles';

type NativeElement = React.HTMLAttributes<HTMLDivElement>;

export interface CategoriesTagsListProps {
  onClick?: NativeElement['onClick'];
  tagsList: TopCategories[];
  selectedFilters: SelectedFilters;
  className?: string;
  productsCount: number;
  onFilterChange: (
    slug: string,
    value: string | [number, number],
    checked: boolean,
    withUpdate?: boolean
  ) => void;
  isLoading?: boolean;
  isOpenModal?: boolean;
}

export function CategoriesTagsList({
  tagsList,
  className
}: CategoriesTagsListProps) {
  const slots = styles();
  const router = useRouter();
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);

  if (tagsList.length === 0) return null;

  return (
    <div className={slots.base({ className })}>
      <div className={slots.container()}>
        <UiKitCarouselBase
          showArrows={true}
          className={slots.carousel()}
          loop={false}
          withScrollGestures
          arrowType="arrow"
          arrowPrevClass={slots.arrowPrev()}
          arrowNextClass={slots.arrowNext()}
          classNameIcon={slots.arrowIcon()}
        >
          {tagsList.map((tag, index) => (
            <UiKitCheckboxTag
              key={`${tag.name}-${index}`}
              onChange={() => {
                setActiveCategoryIndex(index);
                router.push(`/${tag.url_key}`);
              }}
              checked={index === activeCategoryIndex}
              label={tag.name}
            />
          ))}
        </UiKitCarouselBase>
      </div>
    </div>
  );
}
